import React from 'react';

const Share = props => {
    const link = window.location.href;
    const title = props.title;

    let whatsAppMessage = `Project: ${title} URL: ${link}`;

    return (
        <div className="share">
            <h4>
                Share this{' '}
                {props.type === 'post' || 'page' ? 'article' : 'project'}
            </h4>
            <div className="share-buttons">
                <ul>
                    <li>
                        <a
                            href={`http://www.facebook.com/share.php?u=${link}&title=Friends for Brands - ${title}`}
                            target="_blank">
                            <i className="icon icon-fb_icon" />
                        </a>
                    </li>
                    <li>
                        <a
                            href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=${link}&title=Friends for Brands - ${title}`}
                            target="_blank">
                            <i className="icon icon-in_icon" />
                        </a>
                    </li>
                    <li>
                        <a
                            href={`mailto:?subject=Friends for Brands - ${title} website&body=Beste,%0A%0aIk heb een artikel gelezen op de Friends for Brands site: ${title}:%0A%0a${link}`}>
                            <i className="icon icon-mail_icon" />
                        </a>
                    </li>
                    <li>
                        <a href={`whatsapp://send?text=${whatsAppMessage}`}>
                            <i className="icon icon-whatsapp_icon" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Share;



// WEBPACK FOOTER //
// ./src/components/Pages/Share.jsx